//#region IMPORT
import React, { useEffect, useMemo, useRef, useState } from 'react';
import PPE_BASIC_04 from './PPE_BASIC_04';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useSearch1 } from './PPE_BASIC_04_QUERY';
//#endregion

function PPE_BASIC_04F(props) {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const [rowData1, setRowData1] = useState([]); //보호구등록 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); //보호구등록 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); //보호구등록 변경 시 데이터

  const imgRef = useRef(null); //작성자 사인
  const equipDate = searchInfo.endDate || dayjs().format('YYYY-MM-DD');

  useEffect(() => {
    // 현재 탭이 3번이 아닌 경우 처리하지 않음
    if (props.value !== 3) return;
    if (!props.searchClick4) return;

    ResetLogic1();

    if (!searchInfo.depCd) {
      props.setSearchClick4(false);
      dispatch(
        showSnackbar({
          message: '부서를 선택해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    if (!props.validateSelection()) {
      props.setSearchClick4(false);
      return;
    }

    SearchLogic1();
    props.setSearchClick4(false);
  }, [props.value, props.searchClick4]);

  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
  };
  //#region 조회
  const context = useMemo(
    () => ({
      search: {
        depCd: searchInfo.depCd || '',
        equipDate,
        params: searchInfo.searchText || '',
      },
    }),
    [searchInfo.depCd, equipDate, searchInfo.searchText]
  );

  const { refetch: Search1 } = useSearch1({
    context: context,
    onSuccess: (rows) => {
      console.log('rows', rows);
      setRowData1(rows);
    },
  });

  const SearchLogic1 = async () => {
    ResetLogic1();
    try {
      await Search1();
    } catch (error) {
      // 에러는 onError에서 처리
    }
  };

  useEffect(() => {
    if (props.value !== 3) return;
    if (!searchInfo.depCd) return;
    if (!props.validateSelection()) return;

    SearchLogic1();
  }, [context]);

  //#endregion
  //#region 저장
  const SaveLogic1 = async () => {
    dispatch(
      showSnackbar({
        message: '조회 전용 페이지입니다.',
        type: 'warning',
      })
    );
  };
  //#endregion
  //#region 삭제
  const DeleteLogic1 = async () => {
    dispatch(
      showSnackbar({
        message: '조회 전용 페이지입니다.',
        type: 'warning',
      })
    );
  };
  //#endregion
  //#region 나머지 함수
  const PrintLogic1 = async () => {
    setLoading(true);
    let headerData = [];
    let tableData = [];
    const grouped = {};
    try {
      rowData1.sort((a, b) => (a.erCd || '').localeCompare(b.erCd || ''));
      rowData1.forEach((item) => {
        const { name, equipNm } = item;
        if (!grouped[name]) {
          grouped[name] = { name };
        }
        const equipCount = Object.keys(grouped[name]).length;
        grouped[name][`equipNm${equipCount}`] = equipNm;
      });

      const result = Object.values(grouped);
      if (result.length > 0) {
        await SearchPhoto(userInfo.sign);
        const selectedDep = searchInfo.depList?.find(
          (e) => e.value === searchInfo.depCd
        );
        headerData.push({
          DEP_NM: selectedDep?.name || '',
          EQUIP_DATE: dayjs(equipDate).format('YYYY-MM-DD'),
          USER_SIGN: !imgRef.current
            ? ''
            : imgRef.current.replace(/^data:image\/[a-z]+;base64,/, ''),
          EQUIP_NM1: !result[0].equipNm1 ? '' : result[0].equipNm1,
          EQUIP_NM2: !result[0].equipNm2 ? '' : result[0].equipNm2,
          EQUIP_NM3: !result[0].equipNm3 ? '' : result[0].equipNm3,
          EQUIP_NM4: !result[0].equipNm4 ? '' : result[0].equipNm4,
          EQUIP_NM5: !result[0].equipNm5 ? '' : result[0].equipNm5,
          EQUIP_NM6: !result[0].equipNm6 ? '' : result[0].equipNm6,
          EQUIP_NM7: !result[0].equipNm7 ? '' : result[0].equipNm7,
          EQUIP_NM8: !result[0].equipNm8 ? '' : result[0].equipNm8,
          EQUIP_NM9: !result[0].equipNm9 ? '' : result[0].equipNm9,
          EQUIP_NM10: !result[0].equipNm10 ? '' : result[0].equipNm10,
          EQUIP_NM11: !result[0].equipNm11 ? '' : result[0].equipNm11,
          EQUIP_NM12: !result[0].equipNm12 ? '' : result[0].equipNm12,
          EQUIP_NM13: !result[0].equipNm13 ? '' : result[0].equipNm13,
          EQUIP_NM14: !result[0].equipNm14 ? '' : result[0].equipNm14,
          EQUIP_NM15: !result[0].equipNm15 ? '' : result[0].equipNm15,
          EQUIP_NM16: !result[0].equipNm16 ? '' : result[0].equipNm16,
        });
        result.forEach((_item) => {
          tableData.push({
            USER_NM: _item.name || '',
            EQUIP_NM1: !_item.equipNm1 || _item.equipNm1 === '' ? '' : 'O',
            EQUIP_NM2: !_item.equipNm2 || _item.equipNm2 === '' ? '' : 'O',
            EQUIP_NM3: !_item.equipNm3 || _item.equipNm3 === '' ? '' : 'O',
            EQUIP_NM4: !_item.equipNm4 || _item.equipNm4 === '' ? '' : 'O',
            EQUIP_NM5: !_item.equipNm5 || _item.equipNm5 === '' ? '' : 'O',
            EQUIP_NM6: !_item.equipNm6 || _item.equipNm6 === '' ? '' : 'O',
            EQUIP_NM7: !_item.equipNm7 || _item.equipNm7 === '' ? '' : 'O',
            EQUIP_NM8: !_item.equipNm8 || _item.equipNm8 === '' ? '' : 'O',
            EQUIP_NM9: !_item.equipNm9 || _item.equipNm9 === '' ? '' : 'O',
            EQUIP_NM10: !_item.equipNm10 || _item.equipNm10 === '' ? '' : 'O',
            EQUIP_NM11: !_item.equipNm11 || _item.equipNm11 === '' ? '' : 'O',
            EQUIP_NM12: !_item.equipNm12 || _item.equipNm12 === '' ? '' : 'O',
            EQUIP_NM13: !_item.equipNm13 || _item.equipNm13 === '' ? '' : 'O',
            EQUIP_NM14: !_item.equipNm14 || _item.equipNm14 === '' ? '' : 'O',
            EQUIP_NM15: !_item.equipNm15 || _item.equipNm15 === '' ? '' : 'O',
            EQUIP_NM16: !_item.equipNm16 || _item.equipNm16 === '' ? '' : 'O',
          });
        });
        const printData = {
          FileName: 'PPE_BASIC_04',
          HeaderData: JSON.stringify(headerData),
          TableData: JSON.stringify(tableData),
        };
        await Commons.Axios(
          'report',
          Global.base.useUrl + Global.urls.Reports.reports,
          printData
        ).then((response) => {
          const blobUrl = URL.createObjectURL(response.data);
          window.open(blobUrl, '_blank');
        });
      } else {
        dispatch(
          showSnackbar({
            message: '인쇄할 항목이 없습니다.',
            type: 'warning',
          })
        );
      }
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const SearchPhoto = async (_path) => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(_path),
        }
      ).then((result) => {
        let data = result.data;
        if (data !== 'Error') {
          imgRef.current = `data:image/png;base64,${data}`;
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
    }
  };
  //#endregion

  return (
    <PPE_BASIC_04
      userInfo={userInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      dateValue={props.dateValue}
      setDateValue={props.setDateValue}
      dateValue1={props.dateValue1}
      setDateValue1={props.setDateValue1}
      dateValue2={props.dateValue2}
      setDateValue2={props.setDateValue2}
      filterClick4={props.filterClick4}
      setFilterClick4={props.setFilterClick4}
      searchClick4={props.searchClick4}
      setSearchClick4={props.setSearchClick4}
      addClick4={props.addClick4}
      setAddClick4={props.setAddClick4}
      saveClick4={props.saveClick4}
      setSaveClick4={props.setSaveClick4}
      deleteClick4={props.deleteClick4}
      setDeleteClick4={props.setDeleteClick4}
      printClick4={props.printClick4}
      setPrintClick4={props.setPrintClick4}
      searchSiteCd={props.searchSiteCd}
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={SearchLogic1}
      SaveLogic1={SaveLogic1}
      DeleteLogic1={DeleteLogic1}
      PrintLogic1={PrintLogic1}
    />
  );
}

export default PPE_BASIC_04F;
